import { useState, useEffect } from 'react';

interface OnboardingTooltipProps {
  storageKey: string;
  message: string;
  visible?: boolean;
  onDismiss?: () => void;
}

export const useOnboardingTooltip = (storageKey: string) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(storageKey)) {
      setVisible(true);
    }
  }, [storageKey]);

  const dismiss = () => {
    localStorage.setItem(storageKey, 'true');
    setVisible(false);
  };

  return { visible, dismiss };
};

export const OnboardingTooltip = ({
  message,
  visible,
  onDismiss,
}: Omit<OnboardingTooltipProps, 'storageKey'>) => {
  if (!visible) return null;

  return (
    <div className="absolute bottom-0 left-0 translate-y-[calc(100%-8px)] z-30 w-64">
      <div className="ml-5 w-3 h-3 bg-primary rotate-45 -mb-1.5 relative z-10" />
      <div className="bg-primary rounded-xl p-3 shadow-lg">
        <div className="flex items-start justify-between gap-2">
          <p className="text-sm text-white font-medium leading-snug">{message}</p>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDismiss?.();
            }}
            className="text-white/70 hover:text-white flex-shrink-0 mt-0.5"
            aria-label="Cerrar"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
